export const KlpPalette = {
    primary: {
        main: '#3d3d3d',
        dark: '#2e2e2e',
        mediumDark: '#737373',
        medium: '#b3b3b3',
        mediumLight: '#e1e1e1',
        light: '#f0f0f0',
        veryLight: '#f9f9f9',
    },
    secondary: {
        main: '#0db28a',
        dark: '#06735c',
        medium: '#cdfae2',
        light: '#e3f9ed',
        veryLight: '#edfbf3',
    },
    tertiary: {
        main: '#3892E6',
        dark: '#0a57a1',
        medium: '#82c3ff',
        light: '#b8dcfc',
        veryLight: '#d9ebfa',
    },
    error: {
        main: '#e41b65',
        light: '#ffe1e1',
    },
    background: {
        default: '#f7f7f7',
        paper: '#FFF',
    },
};
